module.exports = "https://coursera_assets.s3.amazonaws.com/images/77b1ea77b700cc99cc6bcb3087709188.png";